import { Avatar, Col, Row } from "antd";
import { useGetIcon } from "../../hooks/useGetIcon";
import { PaymentDetailsProps } from "./PaymentDetails";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";

export const Fees = ({ paymentRecord }: PaymentDetailsProps) => {
  const { getIcon } = useGetIcon();

  return (
    <Row>
      <Row className="w-100 mb-3 mt-3">
        <p className="h h5">Fees</p>
      </Row>
      <Row className="align-center w-100 justify-space-between item-container mb-2">
        <Col span={4}>
          <Row className="align-center avatar">
            <Avatar
              icon={getIcon("Fees")}
              size={40}
              className="option d-flex justify-center"
            />
          </Row>
        </Col>
        <Col span={12}>
          <Row className="d-block h-100 align-content-center item-title">
            <p className="my-0 text-md w-500">Buyer Fee</p>
          </Row>
        </Col>
        <Col span={6}>
          <Row className="h-100 justify-end item-amount">
            <p className="my-0 text-md w-500 text-no-wrap">
              {getFormattedCurrency(paymentRecord.payerFees)}
            </p>
          </Row>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row className="align-center w-100 justify-space-between item-container mt-2">
        <Col span={4}>
          <Row className="align-center avatar">
            <Avatar
              icon={getIcon("Fees")}
              size={40}
              className="option d-flex justify-center"
            />
          </Row>
        </Col>
        <Col span={12}>
          <Row className="d-block h-100 align-content-center item-title">
            <p className="my-0 text-md w-500">Seller Fee</p>
          </Row>
        </Col>
        <Col span={6}>
          <Row className="h-100 justify-end item-amount">
            <p className="my-0 text-md w-500 text-no-wrap">
              {getFormattedCurrency(paymentRecord.payeeFees)}
            </p>
          </Row>
        </Col>
        <Col span={1}></Col>
      </Row>
    </Row>
  );
};
